module.exports = __webpack_public_path__ + "static/img/blog2.4ac6015a.jpg";